import { render, staticRenderFns } from "./proyectos-home.vue?vue&type=template&id=65bd9c98"
import script from "./proyectos-home.vue?vue&type=script&lang=js"
export * from "./proyectos-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports